import { Injectable } from '@angular/core';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface, AllocationViewCombinedActionInterface } from '../models';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AllocationViewCallToWaitingAreaActionState } from './allocation-view-call-to-waiting-area-action.state';
import {
  AllocationViewCallToWaitingAreaAction,
  AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState,
  AllocationViewCallToWaitingAreaActionSetInitialState,
} from './allocation-view-call-to-waiting-area-action.actions';
import { delay, filter, take } from 'rxjs/operators';
import { AllocationViewAllocateActionLoadAllocationDetails } from '../allocate/allocation-view-allocate-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToWaitingAreaActionFacade
  implements AllocationViewActionInterface, AllocationViewCombinedActionInterface
{
  loaded$: Observable<boolean> = this.store.select(AllocationViewCallToWaitingAreaActionState.getLoaded);

  responseData$: Observable<boolean> = this.store.select(
    AllocationViewCallToWaitingAreaActionState.getCallToWaitingAreaFinished,
  );

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  setInitialState(): void {
    this.store.dispatch(new AllocationViewCallToWaitingAreaActionSetInitialState());
  }

  loadAll(): void {
    this.store.dispatch(new AllocationViewCallToWaitingAreaActionSetInitialState());
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(delay(0), filter(Boolean), take(1))
      .subscribe((actionIdentifier: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewAllocateActionLoadAllocationDetails(actionIdentifier));
      });
  }

  callToWaitingArea(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewCallToWaitingAreaAction({
            identifier,
          }),
        );
      });
  }

  setCloseContainerAfterCompleteState(closeAfterComplete: boolean): void {
    this.store.dispatch(new AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState(closeAfterComplete));
  }
}
